<template>
  <!--
    Without these the bar was a pair of anonymous `<div>`s: its value was
    conveyed only by the width of a coloured rectangle, so a screen reader had
    nothing to report. `aria-valuenow` carries the clamped value for the same
    reason the fill uses it.
  -->
  <div
    class="progress-bar"
    role="progressbar"
    aria-valuemin="0"
    aria-valuemax="100"
    :aria-valuenow="displayValue"
    :aria-valuetext="`${displayValue}%`"
  >
    <div
      class="progress-bar__inner"
      :class="
        showOverflow && overflowing ? 'progress-bar__inner--overflow' : ''
      "
      :style="{
        width: `${constrainedValue}%`,
        'transition-duration': [100, 0].includes(constrainedValue)
          ? '0s'
          : '1s',
      }"
    ></div>
    <span class="progress-bar__status-text">
      <template v-if="showValue">{{ `${displayValue}%` }}</template>
      {{ status }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    value: {
      type: Number,
      required: true,
    },
    status: {
      type: String,
      required: false,
      default: '',
    },
    showValue: {
      type: Boolean,
      required: false,
      default: true,
    },
    showOverflow: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    constrainedValue() {
      return this.showOverflow ? Math.min(this.value, 100) : this.value
    },
    displayValue() {
      return Math.round(this.value)
    },
    overflowing() {
      return this.value > 100
    },
  },
}
</script>
